function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .clsa-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px}\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_2162",
  stroke: "#fff",
  transform: "translate(-945.369 -998.729)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_2160",
  transform: "translate(5.369 9.748)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_2159",
  transform: "translate(941.5 990.48)"
}, /*#__PURE__*/React.createElement("path", {
  id: "scroll-wheel",
  d: "M0 0v7.916",
  className: "clsa-1",
  transform: "translate(13.049 7.668)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_625",
  width: 26.262,
  height: 43.023,
  className: "clsa-1",
  rx: 13.131
}))));

function SvgScroll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.262,
    height: 46.023,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.b479db1e.svg";
export { ForwardRef as ReactComponent };